const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  // 发布挂失包裹
  createLoss ({ state, commit, rootState }, params) {
    return rootState.axios.post('/delivery/v1frontend/delivery-loss/create-loss', params)
  },
  // 发布认领包裹
  createClaim ({ state, commit, rootState }, params) {
    return rootState.axios.post('/delivery/v1backend/delivery-loss/create-claim', params)
  },
  // 包裹列表
  list ({ state, commit, rootState }, params) {
    return rootState.axios.post('/delivery/v1backend/delivery-loss/list', {params})
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/delivery/deliveryLoss.js